var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wrapper"}},[_c('app-menu'),_vm._v(" "),_c('div',{staticClass:"gray-bg",attrs:{"id":"page-wrapper"}},[_c('navbar'),_vm._v(" "),_c('page-header'),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('div',{staticClass:"padding-20"}),_vm._v(" "),_c('app-footer'),_vm._v(" "),_c('voltar-ao-topo')],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3fc87806","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./FrontEnd/componentes/LayoutEditais.vue
// module id = 1995
// module chunks = 0